import { useRef } from "react";
import { createContext, useContext, useState, useEffect } from "react";
import { useUserStore } from "./useUserStore"; // We rely on user info & token
import SpecificAPI from "../services/SpecificApi";

const SchoolsContext = createContext(null);

export const SchoolsProvider = ({ children }) => {
  const hasLoadedRef = useRef(false);
  const { appUser, isAppUserLoading } = useUserStore();

  const [schools, setSchools] = useState([]);
  const [isSchoolsLoading, setIsSchoolsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!appUser || isAppUserLoading) return;

    // 🔁 reset on logout
    if (!appUser) {
      hasLoadedRef.current = false;
      setSchools([]);
      setIsSchoolsLoading(false);
      return;
    }

    // 🛑 fetch once
    if (hasLoadedRef.current) return;
    hasLoadedRef.current = true;

    const loadSchools = async () => {
      try {
        setIsSchoolsLoading(true);

        let schoolsData = [];
        console.log("role: ",appUser?.role);
        
        // if (appUser?.role !== "student") {
          const response = await SpecificAPI.getOrganizations({});
          schoolsData = response?.data || [];
        // }

        
        const filteredSchools = schoolsData.filter((school) =>
          appUser.school_id.includes(school.id),
        );

        setSchools(filteredSchools);
      } catch (err) {
        console.error("Failed to load schools:", err);
        setError(err);
      } finally {
        setIsSchoolsLoading(false);
      }
    };

    loadSchools();
  }, [appUser, isAppUserLoading]);

  return (
    <SchoolsContext.Provider
      value={{ schools, isSchoolsLoading, error, setSchools }}
    >
      {children}
    </SchoolsContext.Provider>
  );
};

export const useSchoolsStore = () => useContext(SchoolsContext);
